import {Controller} from "stimulus"

export default class extends Controller {

    connect() {
        // El formulario contenedor se usa para bloquear el envío de archivos que superen el máximo
        this.form = this.element.closest('form');
        if (this.form) {
            this.onSubmit = (event) => this.validateBeforeSubmit(event);
            this.form.addEventListener('submit', this.onSubmit);
        }
    }

    disconnect() {
        if (this.form && this.onSubmit) {
            this.form.removeEventListener('submit', this.onSubmit);
        }
        this.form = null;
        this.onSubmit = null;
    }

    previewImg(e) {
        const input = e.target;
        const archivo = input.files && input.files[0];

        this.clearError(input);

        if (!archivo) {
            return;
        }

        // Los inputs declaran data-max-size con el mismo límite que valida el modelo
        const maxSize = parseInt(input.dataset.maxSize, 10);
        if (maxSize && archivo.size > maxSize) {
            this.showError(input, this.sizeErrorMessage(archivo, maxSize));
            input.value = ''; // el archivo no llega al servidor
            return;
        }

        if (input.accept && input.accept.indexOf('image/') !== -1 && !archivo.type.startsWith('image/')) {
            this.showError(input, `El archivo "${archivo.name}" no es una imagen válida.`);
            input.value = '';
            return;
        }

        const preview = document.getElementById(input.dataset.preview);
        if (preview) {
            preview.src = URL.createObjectURL(archivo);
        }
    }

    // Red de seguridad: bloquea el envío si queda algún archivo por encima del límite
    validateBeforeSubmit(event) {
        let invalidInput = null;

        this.element.querySelectorAll('input[type="file"][data-max-size]').forEach((input) => {
            const archivo = input.files && input.files[0];
            const maxSize = parseInt(input.dataset.maxSize, 10);

            if (!archivo || !maxSize || archivo.size <= maxSize) {
                return;
            }

            this.showError(input, this.sizeErrorMessage(archivo, maxSize));
            if (!invalidInput) {
                invalidInput = input;
            }
        });

        if (invalidInput) {
            event.preventDefault();
            invalidInput.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
    }

    sizeErrorMessage(archivo, maxSize) {
        return `El archivo "${archivo.name}" pesa ${this.formatSize(archivo.size)} y supera el máximo permitido de ${this.formatSize(maxSize)}. Selecciona una imagen más ligera.`;
    }

    formatSize(bytes) {
        if (bytes >= 1048576) {
            return `${(bytes / 1048576).toFixed(2)} MB`;
        }
        return `${Math.ceil(bytes / 1024)} KB`;
    }

    showError(input, message) {
        const error = this.errorElement(input);

        if (error) {
            error.textContent = message;
            error.classList.remove('d-none');
        }

        input.classList.add('is-invalid');
        input.setAttribute('aria-invalid', 'true');
    }

    clearError(input) {
        const error = this.errorElement(input);

        if (error) {
            error.textContent = '';
            if (input.dataset.error) {
                error.classList.add('d-none');
            }
        }

        input.classList.remove('is-invalid');
        input.removeAttribute('aria-invalid');
    }

    // Slot declarado en el formulario (data-error="id-del-div"); si no existe,
    // se inserta el aviso debajo del propio selector de archivo
    errorElement(input) {
        if (input.dataset.error) {
            return document.getElementById(input.dataset.error);
        }

        const container = input.closest('.custom-file2') || input.parentElement;
        let error = container.querySelector('.img-file-error');

        if (!error) {
            error = document.createElement('div');
            error.className = 'img-file-error text-danger small mt-1';
            container.appendChild(error);
        }

        return error;
    }
}
